import { apiClient } from './client';
import type { VoiceEnrollment, VoicePreferences } from '../voice/types';

interface ApiResponse<T = any> {
  success: boolean;
  data?: T;
  message?: string;
}

export async function enrollVoice(embeddings: number[][]): Promise<ApiResponse<{
  enrollmentCount: number;
  isActive: boolean;
  verificationThreshold: number;
}>> {
  const response = await apiClient.post('/voice/enroll', { embeddings });
  return response.data;
}

export async function getVoiceProfile(): Promise<ApiResponse<VoiceEnrollment | null>> {
  const response = await apiClient.get('/voice/profile');
  return response.data;
}

export async function updateVoicePreferences(
  preferences: Partial<VoicePreferences>,
): Promise<ApiResponse> {
  const response = await apiClient.put('/voice/preferences', preferences);
  return response.data;
}

export async function deleteVoiceProfile(): Promise<ApiResponse> {
  const response = await apiClient.delete('/voice/profile');
  return response.data;
}

export async function getDeepgramToken(): Promise<ApiResponse<{ token: string }>> {
  const response = await apiClient.get('/voice/deepgram-token');
  return response.data;
}
